import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { countryData } from "../utils/countryList/countryList.js";
import { useDispatch } from "react-redux";
import {
  loginRequest,
  loginSuccess,
  loginFail,
} from "../redux/actions/auth.action.js";
import {
  signupRequest,
  signupSuccess,
  signupFail,
} from "../redux/actions/auth.action.js";
import { toast } from "react-toastify";
import { Postdata } from "../utils/api.services.js";
import { Formik, Form, Field } from "formik";
import {
  SignupValidationSchema,
  LoginValidationSchema,
} from "../utils/validation/Validation.js";
import { initTourStateForUser } from "../utils/tourStorage.js";
import HttpService from "../utils/https.services.js";
import googleIcon from "../assets/image/google.png";
import SignInBackground from "../assets/image/Background.png";
import SideLogoImage from "../assets/image/login1.svg";
import "../style/component/login.css";
import "react-toastify/dist/ReactToastify.css";
import SplashVideo from "./splash.js";
import {
  trackEvent,
  identifyUser,
  setUserProperties,
  EVENTS,
} from "./mixpanel.js";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Loader from "./loader/loader.js";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { AF_EVENTS, setAFCustomerUserId, trackAFEvent } from "./appsflyer.js";
// import GoogleLogin from "react-google-login";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import {
  fantasyShareSearch,
  hasFantasyShareParams,
  openSharedFantasyLink,
} from "../utils/fantasyNavigation";

const getDefaultCountryByTimezone = (timezone) => {
  if (timezone.includes("America")) return "us";
  if (["Asia/Kolkata", "Asia/Calcutta"].includes(timezone)) return "in";
  return "us"; // Default to "us" if no match
};

const Login = ({ deviceToken }) => {
  const [hideVideo, setHideVideo] = useState(false);
  const [isSignInForm, setisSignInForm] = useState(true);
  const [isloading, setLoading] = useState(!!localStorage.getItem("Token"));
  const [defaultCountry, setDefaultCountry] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token_device = localStorage.getItem("Device_Token");
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  console.log(timezone, "timeZone");

  useEffect(() => {
    const token = localStorage.getItem("Token");
    if (!token) return;
    if (!hasFantasyShareParams()) {
      navigate("/home");
      return;
    }
    openSharedFantasyLink(navigate);
  }, [navigate]);

  useEffect(() => {
    const timezone1 = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const country = getDefaultCountryByTimezone(timezone1);
    setDefaultCountry(country);
  }, []);

  const formData = {
    country_code: "",
    mobile: "",
    referral_code: "",
  };

  const toggleSigninForm = () => {
    setisSignInForm(!isSignInForm);
  };

  const handleSubmit = (values) => {
    setLoading(true);
    var payload;
    if (token_device || deviceToken) {
      payload = {
        ...values,
        device_token: token_device || deviceToken,
        timezone: timezone,
      };
    } else {
      payload = {
        ...values,
      };
    }

    if (isSignInForm) {
      dispatch(loginRequest());
      Postdata(HttpService().login, payload)
        .then((result) => {
          if (result?.status) {
            dispatch(loginSuccess(result));
            const user = result?.data?.user?.[0];
            initTourStateForUser(user?._id, {
              isNewSignup: false,
              isHome: user?.is_home !== false,
            });
            navigate(`/otp${fantasyShareSearch()}`);
            setLoading(false);
            localStorage.setItem("DeviceToken", deviceToken);
            window.localStorage.setItem(
              "Username",
              result?.data?.user[0]?.username
            );
            window.localStorage.setItem(
              "Referral_Code",
              result?.data?.user[0]?.referral_code
            );
            identifyUser(result?.data?.user[0]?._id); // Track the user by their ID
            setUserProperties({
              $name: result?.data?.user[0]?.username,
              $email: result?.data?.user[0]?.email,
            });
            // trackEvent('Login Success', { userId: result?.data?.user[0]?.id });
            trackAFEvent(AF_EVENTS.AF_LOGIN, {
              status: "success",
              platform: "web",
            });
            trackEvent(EVENTS.MP_LOGIN, {
              status: "success",
              platform: "web",
            });
            setAFCustomerUserId(result?.data?.user[0]?._id);
            // trackAFEvent("pba", "event", {
            //   eventType: "EVENT",
            //   eventName: AF_EVENTS.AF_LOGIN,
            //   eventValue: {
            //     userType: "guest",
            //     method: "google",
            //     status: "success",
            //     platform: "web",
            //   },
            // });
            toast.success(result?.message);
          } else {
            dispatch(loginFail(result?.message));
            setLoading(false);
            trackAFEvent(AF_EVENTS.AF_ERROR_LOGIN, {
              status: "error",
              platform: "web",
            });
            trackEvent(EVENTS.MP_ERROR_LOGIN, {
              status: "error",
              platform: "web",
            });
            toast.error(result?.message);
          }
        })
        .catch((e) => {
          dispatch(loginFail(e?.message));
          setLoading(false);
          trackAFEvent(AF_EVENTS.AF_ERROR_LOGIN, {
            ...payload,
            status: "error",
            message: e?.response?.data?.message,
          });
          trackEvent(EVENTS.MP_ERROR_LOGIN, {
            ...payload,
            status: "error",
            message: e?.response?.data?.message,
          });
          toast.error(e?.response?.data?.message);
        });
    } else {
      dispatch(signupRequest());
      setLoading(true);
      const payload = {
        ...values,
        device_token: token_device || deviceToken,
        timezone: timezone,
      };
      Postdata(HttpService().signup, payload)
        .then((result) => {
          if (result?.status) {
            toast.success(result?.message);
            trackAFEvent(AF_EVENTS.MP_SIGNUP, {
              ...payload,
              status: "success",
            });
            trackEvent(EVENTS.MP_SIGNUP, {
              ...payload,
              status: "success",
            });
            identifyUser(result?.data?.user[0]?._id); // Track the user by their ID
            setUserProperties({
              $name: result?.data?.user[0]?.username || "Guest User",
              $email: result?.data?.user[0]?.email || "",
            });
            dispatch(signupSuccess(result));
            setLoading(false);
            const user = result?.data?.user?.[0];
            initTourStateForUser(user?._id, { isNewSignup: true });
            navigate(`/otp${fantasyShareSearch()}`);
          } else {
            dispatch(signupFail(result?.message));
            setLoading(false);
            trackAFEvent(AF_EVENTS.MP_ERROR_SIGNUP, {
              ...payload,
              status: "error",
              message: result?.message,
            });
            trackEvent(EVENTS.MP_ERROR_SIGNUP, {
              ...payload,
              status: "error",
              message: result?.message,
            });
            toast.error(result?.message);
          }
        })
        .catch((e) => {
          dispatch(signupFail(e?.message));
          setLoading(false);
          trackAFEvent(AF_EVENTS.MP_ERROR_SIGNUP, {
            ...payload,
            status: "error",
            message: e?.response?.data?.message,
          });
          trackEvent(EVENTS.MP_ERROR_SIGNUP, {
            ...payload,
            status: "error",
            message: e?.response?.data?.message,
          });
          toast.error(e?.response?.data?.message);
        });
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setHideVideo(true);
    }, 4000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    localStorage.removeItem("ProfileImage");
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        event.preventDefault(); // Prevents unintended behavior
        document.getElementById("submitButton")?.click(); // Click the button
      }
    };

    document.addEventListener("keydown", handleKeyDown); // Add event listener

    return () => {
      document.removeEventListener("keydown", handleKeyDown); // Cleanup listener
    };
  }, []);

  const handleLoginSuccess = (response) => {
    console.log("Google login successful:", response);
    const token = response?.credential;
    if (token) {
      Postdata(HttpService().socialSignin, { token: token, device_token: token_device, social_type: "google", type: "web" })
        .then((result) => {
          if (result?.status) {
            deviceToken = result?.data?.token;
            dispatch(loginSuccess(result));
            const user = result?.data?.user?.[0];
            initTourStateForUser(user?._id, {
              isNewSignup: result?.data?.show_referral_page === true,
              isHome: user?.is_home !== false,
            });

            localStorage.setItem("DeviceToken", deviceToken);
            localStorage.setItem("Token", deviceToken);
            
            window.localStorage.setItem(
              "Username",
              result?.data?.user[0]?.username
            );
            window.localStorage.setItem(
              "Referral_Code",
              result?.data?.user[0]?.referral_code
            );
            identifyUser(result?.data?.user[0]?._id); // Track the user by their ID
            setUserProperties({
              $name: result?.data?.user[0]?.username,
              $email: result?.data?.user[0]?.email,
            });
            // trackEvent('Login Success', { userId: result?.data?.user[0]?.id });
            trackAFEvent(AF_EVENTS.AF_LOGIN, {
              status: "success",
              platform: "web",
            });
            trackEvent(EVENTS.MP_LOGIN, {
              status: "success",
              platform: "web",
            });
            setAFCustomerUserId(result?.data?.user[0]?._id);
            // trackAFEvent("pba", "event", {
            //   eventType: "EVENT",
            //   eventName: AF_EVENTS.AF_LOGIN,
            //   eventValue: {
            //     userType: "guest",
            //     method: "google",
            //     status: "success",
            //     platform: "web",
            //   },
            // });
            toast.success(result?.message);
             const searchParams = fantasyShareSearch();
             if(result?.data?.show_referral_page){
              navigate(`/referral${searchParams}`);
            }else if (searchParams) {
              navigate(`/${searchParams}`);
            } else {
              navigate("/home");
            }
            setLoading(false);
          } else {
            dispatch(loginFail(result?.message));
            setLoading(false);
            trackAFEvent(AF_EVENTS.AF_ERROR_LOGIN, {
              status: "error",
              platform: "web",
            });
            trackEvent(EVENTS.MP_ERROR_LOGIN, {
              status: "error",
              platform: "web",
            });
            toast.error(result?.message);
          }
        })
        .catch((e) => {
          dispatch(loginFail(e?.message));
          setLoading(false);
        
          toast.error(e?.response?.data?.message);
        });
    }
  };
  const handleLoginFailure = (response) => {
    console.log("Google login failed:", response);
    toast.error("Google login failed. Please try again.");
  }
  return (
    <div>
      <SplashVideo onFinish={() => setHideVideo(true)} />
      <Loader showLoader={isloading} />
      {hideVideo && (
        <div
          className="signin-page"
          style={{ backgroundImage: `url(${SignInBackground})` }}
        >
          <header className="signin-header">
            <span>Rally Bulls</span>
          </header>

          <main className="signin-body">
            <div className="signin-branding">
              <img src={SideLogoImage} alt="Rally Bulls" className="signin-brand-logo" />
              <p className="signin-tagline">Learn to Trade Risk-Free</p>
            </div>

            <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
              <div className="signin-card">
                <h2>Sign In</h2>
                <p className="signin-card-subtitle">
                Securely access your Rally Bulls account.
                </p>

                <button
                  type="button"
                  className="signin-auth-btn"
                  onClick={() =>
                    document
                      .getElementById("google-login-hidden")
                      ?.querySelector('div[role="button"]')
                      ?.click()
                  }
                >
                  <img src={googleIcon} alt="Google" />
                  <span>Continue with Google</span>
                </button>

                <div id="google-login-hidden" style={{ display: "none" }}>
                  <GoogleLogin
                    onSuccess={handleLoginSuccess}
                    onError={handleLoginFailure}
                  />
                </div>
              </div>
            </GoogleOAuthProvider>
          </main>

          <footer className="signin-footer">
            <div className="signin-footer-links">
              <a
                href="https://rallybulls.com/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              <span className="signin-footer-dot">•</span>
              <a
                href="https://rallybulls.com/terms-and-conditions/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms & Conditions
              </a>
            </div>
            <p>By continuing, you agree to our Terms of service.</p>
          </footer>
        </div>
      )}
    </div>
  );
};

export default Login;
